module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/babel-runtime/core-js/symbol/iterator.js
 ** module id = 336
 ** module chunks = 1
 **/